import * as AM_TYPES from 'model/enums/AssociationMeasure'
import * as CATEGORIES from 'model/enums/AttributeCategory'
import BURDEN_TYPES from './BurdenTypes'
import * as DESIGNS from 'model/enums/StudyDesign'
import * as DOCUMENT_TYPES from 'model/enums/StudyDocumentType'
import * as DOCUMENT_SET_TYPES from 'model/enums/DocumentSetType'
import * as FEATURE from 'model/enums/Feature'
import FIELD_TYPES from 'enums/FIELD_TYPES'
import FILTERS from './FILTER_TYPES'
import * as FUNDING_TYPES from 'model/enums/StudyFunding'
import * as INSTITUTION_TYPES from 'model/enums/InstitutionType'
import * as INTERVENTION_TYPES from 'model/enums/InterventionType'
import INTERVENTION_SUBTYPES from './InterventionSubtypes'
import * as APPS from 'model/enums/App'
import * as MODEL from 'model/enums/ModelName'
import * as OBJECTIVES from 'model/enums/StudyObjective'
import * as PAGE from 'model/metadata/pageEnums'
import * as PERMISSION from 'model/enums/Permission'
import * as RANGE_TYPES from 'model/enums/MeanRangeType'
import * as STATUS from 'model/enums/Status'
import * as STUDY_DATE_TYPES from 'model/enums/StudyYears'
import STUDY_SUBTYPES from './StudySubtypes'
import * as STUDY_TYPES from 'model/enums/StudyType'
import * as VALUE_TYPES from 'model/enums/ValueType'
import VIEWS from './VIEW_TYPES'
import * as WORKFLOW from 'model/enums/Workflow'

const ENUMS = {
	AM_TYPES,
	APPS,
	BURDEN_TYPES,
	CATEGORIES,
	DOCUMENT_TYPES,
	DOCUMENT_SET_TYPES,
	DESIGNS,
	FEATURE,
	FIELD_TYPES,
	FILTERS,
	FUNDING_TYPES,
	INSTITUTION_TYPES,
	INTERVENTION_TYPES,
	INTERVENTION_SUBTYPES,
	MODEL,
	OBJECTIVES: Object.values(OBJECTIVES),
	PAGE,
	PERMISSION,
	RANGE_TYPES,
	STATUS,
	STUDY_DATE_TYPES,
	STUDY_SUBTYPES,
	STUDY_TYPES,
	VALUE_TYPES,
	VIEWS,
	WORKFLOW,
}

Object.freeze(ENUMS)

export default ENUMS

export {
	AM_TYPES,
	APPS,
	BURDEN_TYPES,
	CATEGORIES,
	DOCUMENT_TYPES,
	DOCUMENT_SET_TYPES,
	DESIGNS,
	FEATURE,
	FIELD_TYPES,
	FILTERS,
	FUNDING_TYPES,
	INSTITUTION_TYPES,
	INTERVENTION_TYPES,
	INTERVENTION_SUBTYPES,
	MODEL,
	OBJECTIVES,
	PAGE,
	PERMISSION,
	RANGE_TYPES,
	STATUS,
	STUDY_DATE_TYPES,
	STUDY_SUBTYPES,
	STUDY_TYPES,
	VALUE_TYPES,
	VIEWS,
	WORKFLOW,
}
